import React from 'react';
import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@roger/ui-components';
import { Loader2 } from 'lucide-react';
import type {
  AgencyResponse,
  UserManagerUserResponse,
} from '../../../services/api/types.gen';

export interface ConfirmRemoveDialogProps {
  open: boolean;
  agency: AgencyResponse | null;
  user: UserManagerUserResponse | null;
  isRemoving: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const ConfirmRemoveDialog: React.FC<ConfirmRemoveDialogProps> = ({
  open,
  agency,
  user,
  isRemoving,
  onClose,
  onConfirm,
}) => {
  const fullName = user
    ? [user.first_name, user.last_name].filter(Boolean).join(' ') || user.email
    : '';

  return (
    <Dialog open={open} onOpenChange={v => !v && onClose()}>
      <DialogContent className='max-w-sm'>
        <DialogHeader>
          <DialogTitle>Remove user from agency</DialogTitle>
        </DialogHeader>
        <div className='py-2'>
          <p className='text-sm text-muted-foreground'>
            Remove{' '}
            <span className='font-medium text-foreground'>{fullName}</span>
            {' from '}
            <span className='font-medium text-foreground'>
              {agency?.written_name}
            </span>
            ?
          </p>
          <p className='text-sm text-muted-foreground mt-2'>
            This deactivates their membership and removes their roles and clinic
            access at this agency. They will show as deactivated in the User
            Manager; reactivating them restores no roles or clinics.
          </p>
        </div>
        <DialogFooter>
          <Button variant='outline' onClick={onClose} disabled={isRemoving}>
            Cancel
          </Button>
          <Button
            variant='destructive'
            onClick={onConfirm}
            disabled={isRemoving}
          >
            {isRemoving && <Loader2 className='h-4 w-4 animate-spin mr-2' />}
            Remove user
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ConfirmRemoveDialog;
